customElements.get("product-info") ||
  customElements.define(
    "product-info",
    class extends HTMLElement {
      constructor() {
        super(),
          (this.input = this.querySelector(".quantity__input")),
          (this.currentVariant = this.querySelector(".product-variant-id")),
          (this.variantSelects = this.querySelector("variant-radios")),
          (this.submitButton = this.querySelector('[type="submit"]'));
      }
      cartUpdateUnsubscriber = void 0;
      variantChangeUnsubscriber = void 0;
      connectedCallback() {
        this.input &&
          ((this.quantityForm = this.querySelector(".product-form__quantity")),
          this.quantityForm &&
            (this.setQuantityBoundries(),
            this.dataset.originalSection ||
              (this.cartUpdateUnsubscriber = subscribe(
                PUB_SUB_EVENTS.cartUpdate,
                this.fetchQuantityRules.bind(this)
              )),
            (this.variantChangeUnsubscriber = subscribe(
              PUB_SUB_EVENTS.variantChange,
              (t) => {
                const i = this.dataset.originalSection
                  ? this.dataset.originalSection
                  : this.dataset.section;
                t.data.sectionId === i &&
                  (this.updateQuantityRules(t.data.sectionId, t.data.html),
                  this.setQuantityBoundries());
              }
            ))));
      }
      disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(),
          this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
      }
      setQuantityBoundries() {
        const t = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };
        let i = t.min;
        const a = null === t.max ? t.max : t.max - t.cartQuantity;
        null !== a && (i = Math.min(i, a)),
          t.cartQuantity >= t.min && (i = Math.min(i, t.step)),
          (this.input.min = i),
          (this.input.max = a),
          (this.input.value = i),
          publish(PUB_SUB_EVENTS.quantityUpdate, void 0);
      }
      fetchQuantityRules() {
        this.currentVariant &&
          this.currentVariant.value &&
          (this.querySelector(
            ".quantity__rules-cart .loading-overlay"
          ).classList.remove("hidden"),
          fetch(
            `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`
          )
            .then((t) => t.text())
            .then((t) => {
              const i = new DOMParser().parseFromString(t, "text/html");
              this.updateQuantityRules(this.dataset.section, i),
                this.setQuantityBoundries();
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(() => {
              this.querySelector(
                ".quantity__rules-cart .loading-overlay"
              ).classList.add("hidden");
            }));
      }
      updateQuantityRules(t, i) {
        const a = i.getElementById(`Quantity-Form-${t}`),
          e = [".quantity__input", ".quantity__rules", ".quantity__label"];
        for (let t of e) {
          const i = this.quantityForm.querySelector(t),
            e = a.querySelector(t);
          if (i && e)
            if (".quantity__input" === t) {
              const t = ["data-cart-quantity", "data-min", "data-max", "step"];
              for (let a of t) {
                const t = e.getAttribute(a);
                null !== t && i.setAttribute(a, t);
              }
            } else i.innerHTML = e.innerHTML;
        }
      }
    }
  );
